var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"breakdance-app-wrapper"},[_c('div',{staticClass:"breakdance-top-bar-wrapper"},[_vm._t("topbar")],2),_c('div',{staticClass:"breakdance-app-body-wrapper"},[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }